module.exports = __webpack_public_path__ + "static/media/community-gardens-data-xl.1d9aaf03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/community-gardens-data-xl.jpg
// module id = 398
// module chunks = 12